import { hometogoCookie } from '../utils/hometogoCookie'
import { hometogoCheckboxState } from '../utils/hometogoCheckboxState'
import { hometogoPopunderNavigation } from '../utils/hometogoPopunderNavigation'
import { useHeaderStore } from '~~/modules/api/stores/header'
import { COTTAGE_LIST_MAP_ROUTE_NAME } from '~~/modules/views/cottage-list/constants'

const BLOCKED_ROUTES: readonly string[] = [COTTAGE_LIST_MAP_ROUTE_NAME]

export function useHometogo() {
  const route = useRoute()
  const headerStore = useHeaderStore()
  const { isHomeToGoCookieSet } = hometogoCookie()
  const { compareWithHomeToGoState, updateState, getState } =
    hometogoCheckboxState()

  const shouldFeatureBeActive = computed(() => {
    const isBlockedRoute = BLOCKED_ROUTES.includes(route.name as string)
    return !headerStore.isApp && !isHomeToGoCookieSet() && !isBlockedRoute
  })

  const shouldShowCheckbox = shouldFeatureBeActive

  const shouldActivatePopunder = computed(() => {
    return shouldFeatureBeActive.value && getState() === true
  })

  if (!compareWithHomeToGoState.value && shouldShowCheckbox.value) {
    updateState(true)
  }

  const checkboxState = compareWithHomeToGoState

  const resetCheckbox = () => {
    updateState(false)
  }

  return {
    checkboxState,
    shouldShowCheckbox,
    shouldActivatePopunder,
    resetCheckbox,
    navigateWithPopunder: hometogoPopunderNavigation,
  }
}
